<script lang="ts">
  import { env as envPublic } from '$env/dynamic/public';
  import type { CTA, FooterGroup } from '$types';

  export let logoUrl: string = '';
  export let logoUrlSecond: string = '';
  export let contact: string = '';
  export let copyright: string = '';
  export let items: FooterGroup[] = [];
  export let links: CTA[] = [];
</script>

<footer class="main">
  <div class="footer-nav">
    <div class="footer-brand footer-nav-item">
      <a href="/">
        <img src={logoUrl} alt={envPublic.PUBLIC_APP_NAME} />
      </a>

      <div class="footer-contact">
        {contact}
      </div>

      {#if logoUrlSecond}
        <a href="/">
          <img src={logoUrlSecond} alt={envPublic.PUBLIC_APP_NAME} />
        </a>
      {/if}

      {#if links.length}
        <div class="links">
          {#each links as link}
            {#if !link.image_url}
              <a href={link.link} class={link?.highlight ? 'highlight' : 'base'}>
                {link.link_text}
              </a>
            {:else}
              <a href={link.link} class="link" title={link.link_text || 'link'}>
                <img src={link.image_url} alt="" />
              </a>
            {/if}
          {/each}
        </div>
      {/if}
    </div>

    {#each items as item}
      <div class="footer-group footer-nav-item">
        <h2>{item.title}</h2>

        <ul>
          {#each item.links as link}
            <li>
              <a href={link.href} target={link.target} rel={item.rel}>
                {link.label}
              </a>
            </li>
          {/each}
        </ul>
      </div>
    {/each}

    {#if copyright}
      <div class="copyright">
        {copyright}
      </div>
    {/if}
  </div>
</footer>
